import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import classes from "./SuccessPage.module.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import LanguageSelector from "./LanguageSelector";
import { LanguageContext } from "./LanguageContext";
import bannerEN from "../images/GameBanner.png";
import bannerAR from "../images/arbicbanner.png";

const content = {
  "3": {
    title: "Door 2 Games",
    desc: "Dive into 50+ thrilling games across action, puzzle, sports, and more.",
    details: "Your details",
    mobile: "Mobile Number (MSISDN)",
    placeholder: "e.g. 9876543210",
    subscribe: "Subscribe",
    subscribeText: "Subscribe to the Service",

    // ✅ Cards content
    optoutTitle: "Opt-out method:",
    optoutDesc:
      "To unsubscribe anytime, reply STOP to ***** or visit *******. After unsubscribing, access will stop instantly.",

    subTitle: "Subscription Details",
    daily: "Daily Pack:",
    trial: "Free Trial:",
    price: "300 IQD / Day",
    trialText: "3 days free for new users only",

    infoTitle: "Additional Info",
    provider: "Provider:",
    help: "For help, contact support via the Help section in the portal.",

    subscribe: "Subscribe",
    subscribeText: "Subscribe to the Service",
    description: "This service offers a collection of premium online games. New Asiacell subscribers enjoy the first three days free. After the free period, a daily charge of 300 Iraqi dinars will apply. To unsubscribe, send 0 to 2055 free of charge.",
    description2:
      "This service is a collection of special electronic games. For Asiacell subscribers, the first three days are free. After the free period ends, a fee of 300 IQD per day will be deducted. To cancel, send 0 for free to 2055.",
  },

  "2": {
    // title: "باب 2 ألعاب",
    title: "Door 2 Games",
    desc: "استمتع بأكثر من 50 لعبة ممتعة.",
    details: "بياناتك",
    mobile: "رقم الهاتف",
    placeholder: "مثال: 9876543210",
    // subscribe: "اشترك",
    subscribe: "اشترك",
    subscribeText: "اشترك في الخدمة",

    // ✅ Cards content
    optoutTitle: "طريقة الإلغاء:",
    optoutDesc: "لإلغاء الاشتراك، أرسل STOP.",

    subTitle: "تفاصيل الاشتراك",
    daily: "الباقة اليومية:",
    trial: "تجربة مجانية:",
    price: "300 IQD / يوم",
    trialText: "3 أيام مجانية",

    infoTitle: "معلومات إضافية",
    provider: "مزود الخدمة:",
    help: "للمساعدة، تواصل مع الدعم.",

    subscribe: "اشترك",
    subscribeText: "اشترك في الخدمة",
    description: "هذه الخدمة عبارة عن مجموعة من الألعاب الإلكترونية المميزة. لمشتركي آسياسيل الجدد، أول ثلاثة أيام مجانية. بعد انتهاء الفترة المجانية سيتم خصم 300 دينار عراقي يومياً. لإلغاء الاشتراك، أرسل 0 مجاناً إلى 2055.",
    description2:
      "هذه الخدمة عبارة عن مجموعة من الألعاب الإلكترونية المميزة. لمشتركي آسياسيل، أول ثلاثة أيام مجانية. بعد انتهاء الفترة المجانية سيتم خصم 300 دينار عراقي يومياً. لإلغاء الاشتراك، أرسل 0 مجاناً إلى 2055.",
  },
};

const banners = {
  "3": bannerEN,
  "2": bannerAR,
};

const SuccessPage = () => {
  const [msisdn, setMsisdn] = useState("");
  const [clickID, setClickID] = useState("");
  const [mcpuniqid, setMcpuniqid] = useState("");
  const [antifraudId, setAntifraudId] = useState("")
  const { lang } = useContext(LanguageContext);
  const t = content[lang] || content["3"];
  const currentBanner = bannerEN;

  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  console.log(antifraudId, "id---")

  useEffect(() => {
    if (searchParams.get("msisdn")) {
      setMsisdn(searchParams.get("msisdn"));
    }
    else {
      navigate("/home");
    }
  }, [searchParams]);

  useEffect(() => {
    document.body.dir = lang === "2" ? "rtl" : "ltr";

    const loadAntiFraud = async () => {
      try {
        setLoading(true);
        const userIp = await getUserIP();

        const response = await axios.get("http://lp-asiacell.door2game.com/antifraud", {
          params: {
            page: 1,
            userIp,
            msisdn,
          },
        });
        console.log(response?.data?.data, "response----------")

        if (response.data.success) {
          const click = response.data.clickId;
          const mcp = response.data.mcpuniqid || "";
          const antifraud = response.data.antifrauduniqid

          setClickID(click);
          setMcpuniqid(mcp);
          setAntifraudId(antifraud)

          localStorage.setItem("clickID", click);
          localStorage.setItem("mcp", mcp);


          const scriptFromAPI = response?.data?.data;

          if (scriptFromAPI) {
            const oldScript = document.getElementById("anti-fraud-script");
            if (oldScript) {
              oldScript.remove();
            }

            const scriptTag = document.createElement("script");
            scriptTag.id = "anti-fraud-script";
            scriptTag.type = "text/javascript";

            scriptTag.textContent = scriptFromAPI;

            document.head.appendChild(scriptTag);
          }

          console.log("AntiFraud success:", response.data);
        } else {
          console.error("AntiFraud failed:", response.data);
        }
      } catch (err) {
        console.error(" AntiFraud error:", err);
      }
      finally {
        setLoading(false);
      }
    };
    if (msisdn) {
      loadAntiFraud();
    }
  }, [lang, msisdn]);

  //  Get Public IP
  const getUserIP = async () => {
    try {
      const res = await axios.get("https://api.ipify.org?format=json");
      return res.data.ip;
    } catch (err) {
      console.error("IP fetch failed:", err);
      return "0.0.0.0";
    }
  };

  // Subscribe Flow
  const handleSubscribe = async () => {
    if (!msisdn) {
      navigate("/home");
      return;
    }

    const clickID = localStorage.getItem("clickID");
    const mcp = localStorage.getItem("mcp");

    let langId = lang === "2" ? "2" : "3"

    let opSPID = '12515'

    let stringMsisdn = String(msisdn);


    try {
      // Step 1: AntiFraud

      setLoading(true);

      // if (!clickID || !mcp) {
      if (loading) {
        alert("AntiFraud not ready yet");
        return;
      }

      await axios.post('http://lp-asiacell.door2game.com/print-logs', {
        request: "Antifraud First Logs",
        response: {
          mcp,
          msisdn,
          antifraudId,
          clickID
        }
      })

      const params = new URLSearchParams({
        uniqid: mcp,
        msisdn: String(msisdn),
        ClickID: clickID,
      });

      // navigate(`/he/confirm?uniqid=${mcp}&msisdn=${msisdn}&ClickID=${clickID}`);
      navigate(`/he/confirm?${params.toString()}`);

      // await axios.post('http://lp-asiacell.door2game.com/print-logs', {
      //   request: "HE redirect Logs",
      //   response: `http://iq.as.heliveservices.com/asia-he/iq/HE/v1.2/doubleclick/sub.php?serviceId=22&spId=3021&shortcode=2055&msisdn=${stringMsisdn}&ClickID=${antifraudId}&ChannelID=22800&opSPID=${opSPID}&LanguageID=${langId}`
      // })

      // window.location.href = `http://iq.as.heliveservices.com/asia-he/iq/HE/v1.2/doubleclick/sub.php?serviceId=22&spId=3021&shortcode=2055&msisdn=${stringMsisdn}&ClickID=${antifraudId}&ChannelID=22800&opSPID=${opSPID}&LanguageID=${langId}`

    } catch (error) {
      console.error("Subscribe error:", error);
      // window.location.href = `http://iq.as.heliveservices.com/asia-he/iq/HE/v1.2/doubleclick/sub.php?serviceId=22&spId=3021&shortcode=2055&msisdn=${stringMsisdn}&ClickID=${antifraudId}&ChannelID=22800&opSPID=${opSPID}&LanguageID=${langId}`
      // alert("Something went wrong. Please try again.");
    }
    finally {
      setLoading(false);
    }
  };
  // await fetchAntiFraud(msisdn);

  // const clickID = localStorage.getItem("clickID");
  // const mcp = localStorage.getItem("mcp");

  //   if (!clickID || !mcp) {
  //     alert("AntiFraud not ready yet");
  //     return;
  //   }

  //   await fetch(
  //     `http://host/sendPincode?msisdn=${msisdn}&ClickID=${clickID}`
  //   );

  //   navigate(`/confirm?uniqid=${mcp}&msisdn=${msisdn}`);
  // };

  return (
    <div className={classes.section_hero}>
      <LanguageSelector />

      {/* Hero */}
      <div className={classes.slider_content}>
        <h2>{t.title}</h2>
        <p>{t.desc}</p>
      </div>

      {/* Banner */}
      <div className={classes.banner_wrapper}>
        <img
          src={currentBanner}
          alt="Banner"
          className={classes.banner_img}
        />
      </div>

      <div className={classes.login_cards_wrapper}>
        {/* Login Section */}
        <div className={classes.login_container}>
          {/* <p className={classes.login_subtitle}>{t.details}</p> */}

          {/* <label className={classes.login_label}>{t.mobile}</label>

          <input
            type="tel"
            placeholder={t.placeholder}
            value={msisdn}
            onChange={(e) => setMsisdn(e.target.value)}
            maxLength="15"
            className={classes.login_input}
          /> */}

          {loading ? (<div style={{ width: "100%", padding: "10px", display: "flex", justifyContent: "center", alignItems: 'center' }}>

            <div className={classes.spinner}></div>
          </div>) : (
            <>
              <button
                onClick={handleSubscribe}
                // class='AFsubmitbtn'
                className={`AFsubmitbtn`}
                // className={`${classes.login_button}`}
                id="AFsubmitbtn"
              // className={classes.login_button}
              >
                {t.subscribe}
              </button>

            </>
          )}

          {/* <p className={classes.subscribe_text}>
            {t.subscribeText}
          </p> */}
        </div>

        <p className={classes.subscribe_text}>
          {t.subscribeText}
        </p>

        {/* Description */}
        <div className={classes.description_box}>
          <p>{t.description}</p>
        </div>

        {/* Cards Section */}
        {/* <div className={classes.cards_container}>
          <div className={classes.card}>
            <h4>{t.optoutTitle}</h4>
            <p>{t.optoutDesc}</p>
          </div>

          <div className={classes.card}>
            <h4>{t.subTitle}</h4>
            <p>
              <strong>{t.daily}</strong> {t.price}
              <br />
              <strong>{t.trial}</strong> {t.trialText}
            </p>
          </div>

          <div className={classes.card}>
            <h4>{t.infoTitle}</h4>
            <p>
              <strong>{t.provider}</strong> Rainboo Softmate Pvt Ltd.
              <br />
              {t.help}
            </p>
          </div>
        </div> */}

      </div>

      <div className={classes.partner_logo_container}>
        <div className={classes.partner_logo}></div>
      </div>
    </div>
  );
};

export default SuccessPage;